var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEmail, IsIn, IsNumber, IsOptional, IsString, Matches, MaxLength, ValidateIf, } from 'class-validator';
import { countryRegex } from '../../countries.js';
import { IsTelephoneNumber } from '../../user/validators/IsTelephoneNumber.decorator.js';
import { CALENDAR_INTERVAL_VALUES } from '../const/calendar-interval.const.js';
export class UpdateOfficeLocationDto {
    name;
    abbreviation;
    ownerId;
    /** The phone field's own check (libphonenumber); empty means no number. */
    telephone;
    /**
     * @deprecated No longer used. Kept as an optional, ignored field so older
     * frontend bundles that still send it don't trip `forbidNonWhitelisted`.
     * Remove once no old clients remain.
     */
    countTherapists;
    street;
    zip;
    town;
    countryCode;
    subdivisionCode;
    usesSeparateInvoiceAddress;
    companyNameForInvoice;
    streetForInvoice;
    zipForInvoice;
    townForInvoice;
    countryCodeForInvoice;
    //Opening hours
    mondayFrom;
    mondayTo;
    mondayClosed;
    tuesdayFrom;
    tuesdayTo;
    tuesdayClosed;
    wednesdayFrom;
    wednesdayTo;
    wednesdayClosed;
    thursdayFrom;
    thursdayTo;
    thursdayClosed;
    fridayFrom;
    fridayTo;
    fridayClosed;
    saturdayFrom;
    saturdayTo;
    saturdayClosed;
    sundayFrom;
    sundayTo;
    sundayClosed;
    sloganLine1;
    sloganLine2;
    logoFile;
    email;
    isPinoTestOfficeLocation;
    /**
     * Calendar grid interval in minutes. Must be a divisor of 60
     * ({@link CALENDAR_INTERVAL_VALUES}) so the grid math stays integral.
     */
    calendarInterval;
}
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(4),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "ownerId", void 0);
__decorate([
    ValidateIf((_, value) => value !== null && value !== undefined && value !== ''),
    IsString(),
    IsTelephoneNumber(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDto.prototype, "telephone", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDto.prototype, "countTherapists", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "street", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "zip", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "town", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    Matches(countryRegex),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "countryCode", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(8),
    __metadata("design:type", Object)
], UpdateOfficeLocationDto.prototype, "subdivisionCode", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "usesSeparateInvoiceAddress", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "companyNameForInvoice", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "streetForInvoice", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "zipForInvoice", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "townForInvoice", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    Matches(countryRegex),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "countryCodeForInvoice", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "mondayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "mondayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "mondayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "tuesdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "tuesdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "tuesdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "wednesdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "wednesdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "wednesdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "thursdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "thursdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "thursdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "fridayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "fridayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "fridayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "saturdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "saturdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "saturdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "sundayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "sundayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "sundayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(30),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "sloganLine1", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(30),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "sloganLine2", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], UpdateOfficeLocationDto.prototype, "logoFile", void 0);
__decorate([
    IsEmail(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDto.prototype, "email", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDto.prototype, "isPinoTestOfficeLocation", void 0);
__decorate([
    IsOptional(),
    IsIn(CALENDAR_INTERVAL_VALUES),
    __metadata("design:type", Number)
], UpdateOfficeLocationDto.prototype, "calendarInterval", void 0);
//# sourceMappingURL=update-office-location.dto.js.map